import React from "react";
import { graphql } from "gatsby";
import Layout from "../components/layout";
import SEO from "../components/seo";
import Listing from "../components/Listing";
export default ({ data, location }) => {
  const posts = data.allMarkdownRemark.nodes;
  console.log("::posts", posts);
  if (posts.length === 0) {
    return <p>No posts</p>;
  }
  return (
    <Layout location={location}>
      <SEO title="" />
      {posts.length ? (
        <div className="listings">
          {posts.map((post, i) => (
            <Listing {...{ post }} key={i} />
          ))}
        </div>
      ) : (
        ""
      )}
    </Layout>
  );
};
export const pageQuery = graphql`
  {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      nodes {
        excerpt
        fields {
          slug
        }
        frontmatter {
          title
          date(formatString: "DD MMM YYYY")
          description
          tags
          # OPTIMISATION somehow filter only first item, as presumably it's generating thumbs for all nested post images
          images {
            publicURL
            childImageSharp {
              gatsbyImageData(
                width: 400
                height: 250
                placeholder: NONE
                layout: FIXED
              )
              #  Previous plugin.....
              # fixed(width: 400, height: 250) {
              #     # ...GatsbyImageSharpFixed
              #     ...GatsbyImageSharpFixed_noBase64
              #     # ...GatsbyImageSharpFixed_tracedSVG
              #     # ...GatsbyImageSharpFixed_withWebp
              #     # ...GatsbyImageSharpFixed_withWebp_tracedSVG # doesn't work with animated images >_<
              #     # ...GatsbyImageSharpFixed_withWebp_noBase64 # if i get sick of blurring
              #   }
            }
          }
        }
      }
    }
  }
`;
